export const PenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      className="hover:shadow-xl"
      d="M12.9342 0.513428L10.8443 2.3481L15.0241 6.01743L17.114 4.18277L12.9342 0.513428ZM8.75445 4.18277L0.394897 11.5214V15.1908H4.57467L12.9342 7.8521L8.75445 4.18277Z"
      fill="#353535"
    />
  </svg>
);
export const CalendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <path
      d="M12.5966 3.53935V1.96558M12.5966 3.53935V5.11312M12.5966 3.53935H8.5966M1.92993 8.26066V15.3426C1.92993 16.2118 2.72587 16.9164 3.70771 16.9164H16.1522C17.134 16.9164 17.9299 16.2118 17.9299 15.3426V8.26066H1.92993Z"
      stroke="#6B6B6B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.92993 8.2605V5.11295C1.92993 4.24379 2.72587 3.53918 3.70771 3.53918H5.48549"
      stroke="#6B6B6B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.48547 1.96558V5.11312"
      stroke="#6B6B6B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9299 8.2605V5.11295C17.9299 4.24379 17.134 3.53918 16.1521 3.53918H15.7077"
      stroke="#6B6B6B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <path
      d="M5.90955 7.10828H13.0207"
      stroke="#52DA70"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.90955 7.10828H13.0207"
      stroke="url(#paint0_linear_214_1131)"
      strokeOpacity="0.2"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.02039 10.3625H5.90927"
      stroke="#52DA70"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.02039 10.3625H5.90927"
      stroke="url(#paint1_linear_214_1131)"
      strokeOpacity="0.2"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0204 10.3625H13.9093"
      stroke="#52DA70"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0204 10.3625H13.9093"
      stroke="url(#paint2_linear_214_1131)"
      strokeOpacity="0.2"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.46497 13.6165V8.25556C1.46497 8.03525 1.51387 7.81714 1.60871 7.61464L3.66985 3.21285C3.95 2.61458 4.59273 2.22668 5.30389 2.22668H13.626C14.3372 2.22668 14.9799 2.61458 15.2601 3.21285L17.3212 7.61464C17.4161 7.81714 17.465 8.03525 17.465 8.25556V13.6165M1.46497 13.6165V15.5691C1.46497 15.8387 1.70375 16.0572 1.9983 16.0572H4.48719C4.78174 16.0572 5.02052 15.8387 5.02052 15.5691V13.6165M1.46497 13.6165H5.02052M17.465 13.6165V15.5691C17.465 15.8387 17.2262 16.0572 16.9316 16.0572H14.4427C14.1482 16.0572 13.9094 15.8387 13.9094 15.5691V13.6165M17.465 13.6165H13.9094M5.02052 13.6165H13.9094"
      stroke="#52DA70"
      strokeOpacity="0.77"
      strokeWidth="2.5"
    />
    <path
      d="M1.46497 13.6165V8.25556C1.46497 8.03525 1.51387 7.81714 1.60871 7.61464L3.66985 3.21285C3.95 2.61458 4.59273 2.22668 5.30389 2.22668H13.626C14.3372 2.22668 14.9799 2.61458 15.2601 3.21285L17.3212 7.61464C17.4161 7.81714 17.465 8.03525 17.465 8.25556V13.6165M1.46497 13.6165V15.5691C1.46497 15.8387 1.70375 16.0572 1.9983 16.0572H4.48719C4.78174 16.0572 5.02052 15.8387 5.02052 15.5691V13.6165M1.46497 13.6165H5.02052M17.465 13.6165V15.5691C17.465 15.8387 17.2262 16.0572 16.9316 16.0572H14.4427C14.1482 16.0572 13.9094 15.8387 13.9094 15.5691V13.6165M17.465 13.6165H13.9094M5.02052 13.6165H13.9094"
      stroke="url(#paint3_linear_214_1131)"
      strokeOpacity="0.2"
      strokeWidth="2.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_214_1131"
        x1="9.4651"
        y1="7.10828"
        x2="9.4651"
        y2="8.10828"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_214_1131"
        x1="5.46483"
        y1="10.3625"
        x2="5.46483"
        y2="11.3625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_214_1131"
        x1="13.4649"
        y1="10.3625"
        x2="13.4649"
        y2="11.3625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_214_1131"
        x1="9.46497"
        y1="2.22668"
        x2="9.46497"
        y2="16.0572"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </svg>
);
export const DownIcon = (
  <div className="flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="4"
      viewBox="0 0 6 4"
      fill="none"
    >
      <path d="M3 4L0.401924 0.25L5.59808 0.25L3 4Z" fill="#636363" />
    </svg>
  </div>
);
export const UpIcon = (
  <div className="flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="4"
      viewBox="0 0 6 4"
      fill="none"
    >
      <path d="M3 0L5.59808 3.75L0.401924 3.75L3 0Z" fill="#636363" />
    </svg>
  </div>
);
export const DownIconBig = (
  <div className="flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 6 4"
      fill="none"
    >
      <path d="M3 4L0.401924 0.25L5.59808 0.25L3 4Z" fill="#8f8f8f" />
    </svg>
  </div>
);
export const UpIconBig = (
  <div className="flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 6 4"
      fill="none"
    >
      <path d="M3 0L5.59808 3.75L0.401924 3.75L3 0Z" fill="#8f8f8f" />
    </svg>
  </div>
);
export const CalendarUnsetIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M12.1317 3.31572V1.6886M12.1317 3.31572V4.94283M12.1317 3.31572H8.13169M1.46503 8.19707V15.5191C1.46503 16.4178 2.26096 17.1462 3.2428 17.1462H15.6872C16.6691 17.1462 17.465 16.4178 17.465 15.5191V8.19707H1.46503Z"
      stroke="#FF0000"
      strokeOpacity="0.76"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1317 3.31572V1.6886M12.1317 3.31572V4.94283M12.1317 3.31572H8.13169M1.46503 8.19707V15.5191C1.46503 16.4178 2.26096 17.1462 3.2428 17.1462H15.6872C16.6691 17.1462 17.465 16.4178 17.465 15.5191V8.19707H1.46503Z"
      stroke="url(#paint0_linear_214_1085)"
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.46503 8.19703V4.94279C1.46503 4.04416 2.26096 3.31567 3.2428 3.31567H5.02058"
      stroke="#FF0000"
      strokeOpacity="0.76"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.46503 8.19703V4.94279C1.46503 4.04416 2.26096 3.31567 3.2428 3.31567H5.02058"
      stroke="url(#paint1_linear_214_1085)"
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.02057 1.6886V4.94284"
      stroke="#FF0000"
      strokeOpacity="0.76"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.02057 1.6886V4.94284"
      stroke="url(#paint2_linear_214_1085)"
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.465 8.19703V4.94279C17.465 4.04416 16.6691 3.31567 15.6872 3.31567H15.2428"
      stroke="#FF0000"
      strokeOpacity="0.76"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.465 8.19703V4.94279C17.465 4.04416 16.6691 3.31567 15.6872 3.31567H15.2428"
      stroke="url(#paint3_linear_214_1085)"
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_214_1085"
        x1="9.46503"
        y1="1.6886"
        x2="9.46503"
        y2="17.1462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_214_1085"
        x1="3.2428"
        y1="3.31567"
        x2="3.2428"
        y2="8.19703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_214_1085"
        x1="5.52057"
        y1="1.6886"
        x2="5.52057"
        y2="4.94284"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_214_1085"
        x1="16.3539"
        y1="3.31567"
        x2="16.3539"
        y2="8.19703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" stopOpacity="0.5" />
      </linearGradient>
    </defs>
  </svg>
);

export const DueBillLate = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 28 25"
    fill="none"
  >
    <path
      d="M6.22608 14.55L11.3584 19.2746L20.779 10.6072L15.6438 5.88521L6.22608 14.55ZM26.7467 8.06469L24.5628 6.05409C24.0081 6.33295 23.3702 6.439 22.7445 6.35636C22.1188 6.27373 21.5391 6.00686 21.092 5.59571C20.645 5.18456 20.3547 4.65125 20.2647 4.07562C20.1746 3.49999 20.2897 2.91301 20.5925 2.40256L18.4087 0.391959C18.1334 0.140875 17.7614 0 17.3738 0C16.9862 0 16.6143 0.140875 16.339 0.391959L0.42602 15.0327C0.153117 15.2859 0 15.6281 0 15.9848C0 16.3414 0.153117 16.6836 0.42602 16.9369L2.61134 18.9448C3.16631 18.6652 3.80485 18.5587 4.43117 18.6413C5.0575 18.7239 5.63784 18.991 6.08516 19.4028C6.53248 19.8145 6.82266 20.3485 6.91217 20.9248C7.00168 21.5011 6.8857 22.0885 6.58163 22.599L8.76695 24.607C9.04186 24.8587 9.41394 25 9.8018 25C10.1897 25 10.5617 24.8587 10.8366 24.607L26.7467 9.96891C27.0203 9.71598 27.1739 9.37365 27.1739 9.0168C27.1739 8.65995 27.0203 8.31763 26.7467 8.06469ZM11.3584 21.4355L3.87744 14.55L15.6452 3.72435L23.1262 10.6072L11.3584 21.4355Z"
      fill="#FE4A49"
    />
  </svg>
);
export const DueBillStandard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 28 25"
    fill="none"
  >
    <path
      d="M6.22608 14.55L11.3584 19.2746L20.779 10.6072L15.6438 5.88521L6.22608 14.55ZM26.7467 8.06469L24.5628 6.05409C24.0081 6.33295 23.3702 6.439 22.7445 6.35636C22.1188 6.27373 21.5391 6.00686 21.092 5.59571C20.645 5.18456 20.3547 4.65125 20.2647 4.07562C20.1746 3.49999 20.2897 2.91301 20.5925 2.40256L18.4087 0.391959C18.1334 0.140875 17.7614 0 17.3738 0C16.9862 0 16.6143 0.140875 16.339 0.391959L0.42602 15.0327C0.153117 15.2859 0 15.6281 0 15.9848C0 16.3414 0.153117 16.6836 0.42602 16.9369L2.61134 18.9448C3.16631 18.6652 3.80485 18.5587 4.43117 18.6413C5.0575 18.7239 5.63784 18.991 6.08516 19.4028C6.53248 19.8145 6.82266 20.3485 6.91217 20.9248C7.00168 21.5011 6.8857 22.0885 6.58163 22.599L8.76695 24.607C9.04186 24.8587 9.41394 25 9.8018 25C10.1897 25 10.5617 24.8587 10.8366 24.607L26.7467 9.96891C27.0203 9.71598 27.1739 9.37365 27.1739 9.0168C27.1739 8.65995 27.0203 8.31763 26.7467 8.06469ZM11.3584 21.4355L3.87744 14.55L15.6452 3.72435L23.1262 10.6072L11.3584 21.4355Z"
      fill="#B6B6B6"
    />
  </svg>
);
export const DueBillCreate = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 28 25"
    fill="none"
    opacity="0.4"
  >
    <path
      d="M6.22608 14.55L11.3584 19.2746L20.779 10.6072L15.6438 5.88521L6.22608 14.55ZM26.7467 8.06469L24.5628 6.05409C24.0081 6.33295 23.3702 6.439 22.7445 6.35636C22.1188 6.27373 21.5391 6.00686 21.092 5.59571C20.645 5.18456 20.3547 4.65125 20.2647 4.07562C20.1746 3.49999 20.2897 2.91301 20.5925 2.40256L18.4087 0.391959C18.1334 0.140875 17.7614 0 17.3738 0C16.9862 0 16.6143 0.140875 16.339 0.391959L0.42602 15.0327C0.153117 15.2859 0 15.6281 0 15.9848C0 16.3414 0.153117 16.6836 0.42602 16.9369L2.61134 18.9448C3.16631 18.6652 3.80485 18.5587 4.43117 18.6413C5.0575 18.7239 5.63784 18.991 6.08516 19.4028C6.53248 19.8145 6.82266 20.3485 6.91217 20.9248C7.00168 21.5011 6.8857 22.0885 6.58163 22.599L8.76695 24.607C9.04186 24.8587 9.41394 25 9.8018 25C10.1897 25 10.5617 24.8587 10.8366 24.607L26.7467 9.96891C27.0203 9.71598 27.1739 9.37365 27.1739 9.0168C27.1739 8.65995 27.0203 8.31763 26.7467 8.06469ZM11.3584 21.4355L3.87744 14.55L15.6452 3.72435L23.1262 10.6072L11.3584 21.4355Z"
      fill="#000000"
    />
  </svg>
);

export const DueBillCompleted = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 28 25"
    fill="none"
  >
    <path
      d="M6.22608 14.55L11.3584 19.2746L20.779 10.6072L15.6438 5.88521L6.22608 14.55ZM26.7467 8.06469L24.5628 6.05409C24.0081 6.33295 23.3702 6.439 22.7445 6.35636C22.1188 6.27373 21.5391 6.00686 21.092 5.59571C20.645 5.18456 20.3547 4.65125 20.2647 4.07562C20.1746 3.49999 20.2897 2.91301 20.5925 2.40256L18.4087 0.391959C18.1334 0.140875 17.7614 0 17.3738 0C16.9862 0 16.6143 0.140875 16.339 0.391959L0.42602 15.0327C0.153117 15.2859 0 15.6281 0 15.9848C0 16.3414 0.153117 16.6836 0.42602 16.9369L2.61134 18.9448C3.16631 18.6652 3.80485 18.5587 4.43117 18.6413C5.0575 18.7239 5.63784 18.991 6.08516 19.4028C6.53248 19.8145 6.82266 20.3485 6.91217 20.9248C7.00168 21.5011 6.8857 22.0885 6.58163 22.599L8.76695 24.607C9.04186 24.8587 9.41394 25 9.8018 25C10.1897 25 10.5617 24.8587 10.8366 24.607L26.7467 9.96891C27.0203 9.71598 27.1739 9.37365 27.1739 9.0168C27.1739 8.65995 27.0203 8.31763 26.7467 8.06469ZM11.3584 21.4355L3.87744 14.55L15.6452 3.72435L23.1262 10.6072L11.3584 21.4355Z"
      fill="#54DA70"
    />
  </svg>
);
export const TrashIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="28"
    viewBox="0 0 22 18"
    fill="none"
  >
    <path
      stroke="#FE4A49"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    />
  </svg>
);

export const TradeInTagIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.00002 4.00002C4.80224 4.00002 4.6089 4.05867 4.44445 4.16855C4.28 4.27843 4.15182 4.43461 4.07614 4.61733C4.00045 4.80006 3.98065 5.00113 4.01923 5.19511C4.05782 5.38909 4.15306 5.56727 4.29291 5.70712C4.43276 5.84698 4.61095 5.94222 4.80493 5.9808C4.99891 6.01939 5.19997 5.99958 5.3827 5.9239C5.56543 5.84821 5.7216 5.72004 5.83149 5.55559C5.94137 5.39114 6.00002 5.1978 6.00002 5.00002C6.00002 4.7348 5.89466 4.48045 5.70712 4.29291C5.51959 4.10537 5.26523 4.00002 5.00002 4.00002ZM19.71 9.78002L10.23 0.320017C10.1368 0.21948 10.0239 0.139192 9.89828 0.0841425C9.7727 0.0290929 9.63713 0.000457809 9.50002 1.67143e-05H3.50002C3.36841 -0.000744179 3.23795 0.0244809 3.11611 0.0742455C2.99427 0.12401 2.88346 0.197335 2.79002 0.290017L0.290017 2.78002C0.197335 2.87346 0.12401 2.98427 0.0742455 3.10611C0.0244809 3.22795 -0.000744179 3.35841 1.67143e-05 3.49002V9.49002C0.0037002 9.75478 0.107283 10.0084 0.290017 10.2L9.78002 19.7C9.97165 19.8828 10.2252 19.9863 10.49 19.99C10.6216 19.9908 10.7521 19.9656 10.8739 19.9158C10.9958 19.866 11.1066 19.7927 11.2 19.7L19.71 11.19C19.8027 11.0966 19.876 10.9858 19.9258 10.8639C19.9756 10.7421 20.0008 10.6116 20 10.48C19.9938 10.2187 19.8904 9.96912 19.71 9.78002ZM10.49 17.59L2.00002 9.09002V3.90002L3.90002 2.00002H9.08002L17.58 10.49L10.49 17.59Z"
      fill="black"
    />
  </svg>
);

export const TradeInTagIconSmall = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.00002 4.00002C4.80224 4.00002 4.6089 4.05867 4.44445 4.16855C4.28 4.27843 4.15182 4.43461 4.07614 4.61733C4.00045 4.80006 3.98065 5.00113 4.01923 5.19511C4.05782 5.38909 4.15306 5.56727 4.29291 5.70712C4.43276 5.84698 4.61095 5.94222 4.80493 5.9808C4.99891 6.01939 5.19997 5.99958 5.3827 5.9239C5.56543 5.84821 5.7216 5.72004 5.83149 5.55559C5.94137 5.39114 6.00002 5.1978 6.00002 5.00002C6.00002 4.7348 5.89466 4.48045 5.70712 4.29291C5.51959 4.10537 5.26523 4.00002 5.00002 4.00002ZM19.71 9.78002L10.23 0.320017C10.1368 0.21948 10.0239 0.139192 9.89828 0.0841425C9.7727 0.0290929 9.63713 0.000457809 9.50002 1.67143e-05H3.50002C3.36841 -0.000744179 3.23795 0.0244809 3.11611 0.0742455C2.99427 0.12401 2.88346 0.197335 2.79002 0.290017L0.290017 2.78002C0.197335 2.87346 0.12401 2.98427 0.0742455 3.10611C0.0244809 3.22795 -0.000744179 3.35841 1.67143e-05 3.49002V9.49002C0.0037002 9.75478 0.107283 10.0084 0.290017 10.2L9.78002 19.7C9.97165 19.8828 10.2252 19.9863 10.49 19.99C10.6216 19.9908 10.7521 19.9656 10.8739 19.9158C10.9958 19.866 11.1066 19.7927 11.2 19.7L19.71 11.19C19.8027 11.0966 19.876 10.9858 19.9258 10.8639C19.9756 10.7421 20.0008 10.6116 20 10.48C19.9938 10.2187 19.8904 9.96912 19.71 9.78002ZM10.49 17.59L2.00002 9.09002V3.90002L3.90002 2.00002H9.08002L17.58 10.49L10.49 17.59Z"
      fill="currentColor"
      className="text-gray-500"
    />
  </svg>
);

export const ChevronDownIcon = (
  <svg
    className="w-3 h-3 ml-1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);
